import {useSubDomain} from 'interface/common/hooks/useSubDomain';
import {ShareModal} from 'interface/stacks/share/components/ShareModal';
import useGenerateShareUrl from 'interface/stacks/share/hooks/useGenerateShareUrl';
import {useEffect, useState} from 'react';
import {useToast} from 'react-native-toast-notifications';
import store from 'store';
import type {Share} from 'store/slices/shared/types';
import {copyLink} from 'utils/common/interactions';

interface SharedShareDialogProps {
  workspaceFolderName: string;
  fetchShareDetails: () => Promise<{id: string; custom_name: string} | null>;
  done: () => void;
}

export function SharedShareDialog({
  workspaceFolderName,
  fetchShareDetails,
  done,
}: SharedShareDialogProps) {
  const toast = useToast();
  const {subdomain} = useSubDomain();

  const [shareId, setShareId] = useState<string | null>(null);

  const {generateShareUrlWithSubdomain} = useGenerateShareUrl();

  const copyShareLink = (share: Share) => {
    const shareURL = generateShareUrlWithSubdomain(share, {
      domain: subdomain,
    });
    copyLink(shareURL);
    toast.show('The share URL was copied to clipboard', {type: 'success'});
  };

  const handleFetchShareDetails = async () => {
    const newShare = await fetchShareDetails();
    if (!newShare) {
      done();
    } else {
      setShareId(newShare.id);
    }
  };

  useEffect(() => {
    if (shareId) {
      const newShareDetails = store.getState().shared.shares[shareId];
      copyShareLink(newShareDetails);
    }
  }, [shareId]);

  useEffect(() => {
    handleFetchShareDetails();
  }, []);

  return (
    <ShareModal
      workspaceFolderName={workspaceFolderName}
      shareId={shareId}
      done={done}
    />
  );
}
